:host {
  --slider-vertical-padding: 25px;
  --slider-track-height: 6px;
  --slider-track-color: var(--chart-100-pressed);
  --time-range-color: var(--blue-layout-400-primary);
  --thumb-size: 14px; // excluding border
  --thumb-border: 3px;
  --transition-speed: 0.1s; // speed of the thumb and time range transition when setting a new range
}

.slider-background {
  padding: var(--slider-vertical-padding) 0;
  cursor: pointer;

  &.invalid-range {
    pointer-events: none;
    cursor: auto;
  }
}

.slider-track {
  width: 100%;
  height: var(--slider-track-height);
  background-color: var(--slider-track-color);
  border-radius: calc(var(--slider-track-height) / 2);
}

.time-range {
  position: relative;
  height: 100%;
  background-color: var(--time-range-color);
  border-radius: calc(var(--slider-track-height) / 2);
  transition: left var(--transition-speed) ease-in-out, width var(--transition-speed) ease-in-out;
}

.min-thumb,
.max-thumb {
  position: absolute;
  height: var(--thumb-size);
  width: var(--thumb-size);
  background-color: var(--time-range-color);
  border-radius: 50%;
  border: var(--thumb-border) solid var(--white-layout-301-level-0-elevation);
  box-shadow: 0 1px 3px 0 var(--grey-layout-201-disabled-text);
  transform: translateY(-50%);
  top: calc(var(--slider-track-height) / 2);
  transition: left var(--transition-speed) ease-in-out, right var(--transition-speed) ease-in-out;
}

.min-thumb {
  left: 0;
}

.max-thumb {
  right: 0;
}

.min-label,
.max-label {
  position: relative;
  white-space: nowrap;
  width: fit-content;
  font-family: var(--font-family-secondary);
  font-size: var(--body-size-small);
  color: var(--body-text-arrows-400);
  transition: left var(--transition-speed) ease-in-out, right var(--transition-speed) ease-in-out;
}

.min-label {
  transform: translate(calc(-50% + var(--thumb-size) / 2), -50%); // align center of label to the thumb center on X axis
  bottom: calc(var(--slider-vertical-padding) / 2); // align label bottom to the center of the slider top padding
}

.max-label {
  // ignore CSS linting error as the CSS calc expression is valid
  transform: translate(calc(-50% + var(--thumb-size) / 2), 50%); // align center of label to the thumb center on X axis
  top: calc(var(--slider-vertical-padding) / 2); // align label top to the center of the slider bottom padding
}
